// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZiqXq","type":"styles_type__1C8j_","choices":"styles_choices__2Yh8Q"};